export default {
  title: 'Carrinho',
};
